import React from "react";
import { Col, Container, Row } from "reactstrap";
import { T } from "../traks";
import Flag from "./Flags";
import { LL, switchLanguage } from "./LL";
import { CURRENT_LANG } from "../config"

export const LanguageButton = () => {
    const englishPath = switchLanguage("en")
    const danishPath = switchLanguage("da")

    let elements = [
        <a alt='Dansk' key='lang_da' href={danishPath}><div className="px-3"><Flag lang='da' className="footer_flag" width='16' height='12' />Vælg dansk</div></a>,
        <a alt='English' key='lang_en' href={englishPath}><div className="px-3"><Flag lang='en' className="footer_flag" width='16' height='12' />Select English</div></a>,
    ];

    if (CURRENT_LANG === 'en')
        elements.reverse();

    return (
        <button className="lang_button border_radius_6px">
            {elements[1]}
        </button>
    );
}

const Footer = (props) => {
    return (
        <Container fluid className="sibilus_footer min_w100 min_h100 py-5">
            <Container className="txt_blue_3">
                <Row>
                    <Col xs={12} className="pb-3">
                        <img src="https://static.sibilus.eu/gfx/pentus-logo-color-0.svg" alt='our logo' width={120} height={55} />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} lg={4} className="font_14px">
                        <div className="pb-3">
                            Pentus ApS
                        </div>
                        <div className="pb-3">
                            Flakhaven 1, 1.
                        </div>
                        <div className="pb-3">
                            DK-5000 Odense C
                        </div>
                        <div className="pb-3">
                            <T>Denmark</T>
                        </div>
                        <div className="pb-3">
                            <a href="mailto:info@pentus.dk" className="text-white">info@pentus.dk</a>
                        </div>
                    </Col>
                    <Col xs={12} lg={8}>
                        <Row>
                            <Col xs={12} lg={3}>
                                <div className="font_18px text-white fw_600 pb-4">
                                    <T>Information</T>
                                </div>
                                <div className="pb-3">
                                    <a alt='terms of use page' href={LL('/termsofuse')}><T>Terms of use</T></a>
                                </div>
                                <div className="pb-3">
                                    <a alt='privacy page' href={LL('/privacy')}><T>Privacy policy</T></a>
                                </div>
                            </Col>
                            <Col xs={12} lg={3}>
                                <div className="font_18px text-white fw_600 pb-4">
                                    <T>Language</T>
                                </div>
                                <div data-render-target="footerLang-root">
                                    <LanguageButton />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
}

export default Footer;
